import React, { useMemo } from "react";
import BackIconIcon from "../../../../assets/images/backIcon.png";
import { useNavigate } from "react-router-dom";

// ----------------------------------------------------------------------------

export default function BackIcon(props) {
  const { onClick, rotate, background } = props;

  const navigate = useNavigate();
  return (
    <div onClick={() => (onClick ? onClick() : navigate(-1))}>
      <img
        src={BackIconIcon}
        style={{
          height: 20,
          width: background ? 20 : 30,
          marginTop: 6,
          objectFit: "contain",
          transform: rotate ? "rotate(180deg)" : "",
          backgroundColor: background ? "white" : "",
          padding: background ? 10 : 0,
          borderRadius: background ? 100 : 0,
        }}
        alt="backIcon"
      />
    </div>
  );
}

// ----------------------------------------------------------------------------
